import React from 'react';
import { Box, Typography } from '@mui/material';

function Page2SubPageF() {
  return (
    <Box p={4}>
      <Typography variant="h4">Government Interface</Typography>
    </Box>
  );
}

export default Page2SubPageF;
